<div class="flex flex-col gap-6">

    @if (screeningAi.isDrafting()) {
    <div aria-busy="true" class="flex flex-col gap-5">
        <bb-ai-thoughts-scroll [thoughts]="screeningAi.streamingThoughts()"
            [isCompiling]="screeningAi.isCompilingBrief()" />
    </div>
    } @else {

    <sbs-brief-basics />

    <bb-field label="What are your requirements?" [required]="true"
        hint="List what you WANT to see — the qualities, topics, tone or moments that make a creator right for this programme. The AI can find literally anything, so be as specific or as broad as you like.">

        <div class="flex flex-col">
            <textarea rows="6" [value]="createScreeningService.lookFor()"
                (input)="setLookFor($any($event.target).value)"
                placeholder="Describe the good stuff — what you WANT to see in a creator's posts, captions and comments…"
                class="w-full resize-y rounded-md border border-border bg-card px-3.5 py-2.5 text-base outline-none focus:border-brand-studio focus:ring-2 focus:ring-brand-studio/25 placeholder:text-muted-foreground"></textarea>
            <p class="mt-1.5 text-right text-[11px] text-muted-foreground" aria-hidden="true">
                {{ lookForCount() }} characters
            </p>
        </div>

        <!-- Forward pointer: this step is positives only; red flags come next. -->
        <div class="mt-3 flex items-start gap-3 rounded-xl border border-brand-studio bg-brand-studio/10 p-3.5">
            <span class="grid size-[30px] shrink-0 place-items-center rounded bg-brand-studio text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    aria-hidden="true">
                    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
                    <line x1="4" x2="4" y1="22" y2="15" />
                </svg>
            </span>
            <p class="m-0 text-[13px] leading-relaxed text-foreground/80">
                <b class="font-bold text-foreground">Just the positives for now.</b>
                This step is only about the <b class="font-bold text-foreground">requirements</b> — the things that make
                a creator a great fit. You'll set the <b class="font-bold text-foreground">red flags</b> (what
                disqualifies them) in the next section.
            </p>
        </div>

        <!-- How to brief the AI -->
        <div class="mt-3.5 rounded-xl border border-border bg-muted p-4">
            <h3 class="mb-2.5 flex items-center gap-2 font-heading text-sm font-bold text-foreground">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-brand-studio-dark dark:text-brand-studio" aria-hidden="true">
                    <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                    <path d="M9 18h6" />
                    <path d="M10 22h4" />
                </svg>
                How to brief the AI
            </h3>
            <ul class="m-0 flex list-none flex-col gap-2 p-0">
                @for (pointer of pointers; track pointer) {
                <li class="flex gap-2.5 text-[13px] leading-relaxed text-foreground/80">
                    <span class="mt-[7px] size-1.5 shrink-0 rounded-full bg-brand-studio" aria-hidden="true"></span>
                    {{ pointer }}
                </li>
                }
            </ul>
        </div>

        <!-- Optional AI draft -->
        <div class="mt-3.5">
            <button type="button" [disabled]="screeningAi.isDrafting()" (click)="draftWithAi()"
                class="inline-flex items-center gap-2 rounded-full border border-brand-studio bg-brand-studio/10 px-3.5 py-1.5 text-xs font-bold text-brand-studio-dark transition-colors hover:bg-brand-studio hover:text-white disabled:opacity-50 dark:text-brand-studio">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    aria-hidden="true">
                    <path
                        d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                </svg>
                Help me write this
            </button>
            @if (screeningAi.draftError()) {
            <p class="mt-2 text-[11px] text-red-500 dark:text-red-400" role="alert">{{ screeningAi.draftError() }}</p>
            }
        </div>

    </bb-field>

    }
</div>
